import { Table } from "elemental-react16";
import { OrderPreviewRow } from "./OrderPreviewRow";
import React from "react";

const OrderTable = ({ orders, path = "/account/orders" }) => {
  if (orders.length === 0) {
    return null
    // return (<p>Keine Bestellungen gefunden.</p>)
  }

  return (
    <div className="table-scroller">
      <Table>
        <colgroup>
          <col width="65%" />
          <col width="15%" />
          <col width="10%" />
          <col width="10%" />
        </colgroup>

        <tbody>
          <tr>
            <th className="ttu">{translate("order number")}</th>
            <th className="ttu tr">{translate("price")}</th>
            <th className="ttu tc">{translate("positions")}</th>
            <th className="ttu tc">{translate("date")}</th>
          </tr>

          {orders.length > 0 && orders.map((order) => <OrderPreviewRow path={path} key={order.id} order={order} />)}
        </tbody>
      </Table>
    </div>
  )
}
export default OrderTable


// WEBPACK FOOTER //
// ./src/theme/hobbyfun/components/OrderTable/OrderTableAccount.js